import * as Yup from "yup";
const emailPattern = /^[A-Z0-9._%+&-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
// const alphabetValidation = /^[a-zA-Z\s-]*$/;
const alphanumeric = /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9]+$/;
const validName = /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z ]+$/;
const validPartName = /^(?!\/)[a-zA-Z\s,_.+/]+$/;
//const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const passwordPattern =/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/;
const categoryNamePattern = /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/;
const categoryCodePattern = /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_\\s]+$/;
const numericValue = /^[0-9]+$/;
const exlude_Equal_slash_start = /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/;

export const ADD_USER_VALIDATIONS = Yup.object().shape({
  deptId: Yup.string().required("This field is required"),
  roleId: Yup.string().required("This field is required"),
  userTypeId: Yup.string().required("This field is required"),
  active: Yup.string().required("This field is required"),
  firstName: Yup.string()
    .required("This field is required")
    .matches(validName, "only letters allowed")
    .trim()
    .max(100, "Max 100 characters required"),
  email: Yup.string()
    .required("This field is required")
    .matches(emailPattern, "Email is not valid")
    .min(4, "Minimum 4 characters required")
    .max(100, "Max 100 characters required"),
  isMobileNo: Yup.boolean(),
  isEmployeId: Yup.boolean(),
  isLastName: Yup.boolean(),
  employeeId:Yup.string().when("isEmployeId",(isEmpId)=>{
    if(isEmpId){
      return Yup.string()
      .required("This field is required")
      .matches(alphanumeric, "Only alphanumeric characters allowed")
      
    }
  }),
  lastName:Yup.string().when("isLastName",(isLastName)=>{
    if(isLastName){
      return Yup.string()
      .required("This field is required")
      .matches(validName, "only letters allowed")
      
    }
  }),
  mobileNumber: Yup.string().when("isMobileNo", (isMobileNo) => {
    if (isMobileNo)
      return Yup.string()
        .required("This field is required")
        .matches(numericValue, "Please enter valid mobile number")
        .min(10, "Minimum 10 characters required")
        .max(10, "Max 10 characters required");
  }),
});

export const ADD_CATEGORY_VALIDATIONS = Yup.object().shape({
  categoryCode: Yup.string()
    .required("This field is required")
    .matches(categoryCodePattern, "can not start with special characters exclude  -_\ ")
    .min(2, "Minimum 2 characters required")
    .max(3, "Max length is 3 char"),
  categoryName: Yup.string()
    .required("This field is required")
    .matches(categoryNamePattern, "Field can only start with alphanumeric, and allowed special characters are -_.&")
    .min(3, "Minimum 3 characters required")
    .max(100, "Max 100 characters required"),
});

export const ADD_DEPARTMENT_VALIDATIONS = Yup.object().shape({
  deptCode: Yup.string().nullable()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can only start with alphanumeric, and allowed special characters are -_.&")
    .min(3, "Minimum 3 characters required")
    .max(50, "Max 50 characters required"),
  name: Yup.string().nullable()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can only start with alphanumeric, and allowed special characters are -_.&")
    .min(3, "Minimum 3 characters required")
    .max(100, "Max 100 characters required"),
});

export const ADD_FAMILY_VALIDATIONS = Yup.object().shape({
  categoryId: Yup.string().required("This field is required"),
  productFamilyName: Yup.string()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can not start with special characters")
    .min(3, "Minimum 3 characters required")
    .max(100, "Max 100 characters required"),
});

export const ADD_FUNCTION_VALIDATIONS = Yup.object().shape({
  deptId: Yup.string().nullable().required("This field is required"),
  name: Yup.string().nullable()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can only start with alphanumeric, and allowed special characters are -_.&")
    .max(100, "Max 100 characters required")
    .min(3, "Min 3 characters required"),
  functionCode: Yup.string().nullable()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can only start with alphanumeric, and allowed special characters are -_.&")
    .max(50, "Max 50 characters required")
    .min(3, "Min 3 characters required"),
});

export const ADD_BRICK_VALIDATIONS = Yup.object().shape({
  categoryId: Yup.string().required("This field is required"),
  productCatFamilyMappingId: Yup.string().required("This field is required"),
  brickName: Yup.string()
    .required("This field is required")
    .matches(
      /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_'",.& ]+$/,
      "Field can not start with special characters"
    )
    .min(3, "Minimum 3 characters required")
    .max(100, "Max 100 characters required"),
  brickCode: Yup.string()
    .required("This field is required")
    .min(2, "Minimum 2 characters required")
    .max(100, "Max 100 characters required")
    .matches(categoryCodePattern, "can not start with special characters exclude  -_\ "),
});

export const ADD_BRAND_VALIDATIONS = Yup.object().shape({
  categoryId: Yup.string().required("This field is required"),
  brickId: Yup.string().required("This field is required"),
  productCatFamilyMappingId: Yup.string().required("This field is required"),
  brandId: Yup.string().required("This field is required"),
  brandName: Yup.string()
    .required("This field is required")
    .matches(/^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])^[a-zA-Z0-9-_.& ]+$/, "Field can not start with special characters")
    .max(100, "Max 100 characters required"),
});

export const SERVICE_ADVISORY_UPLOAD_VALIDATIONS = Yup.object().shape({
  advisoryNumber: Yup.string()
    .required("This field is required")
    .matches(numericValue, "Only numeric value allowed"),
  brandId: Yup.string().required("This field is required"),
  brickId: Yup.string().required("This field is required"),
  modelId: Yup.string().required("This field is required"),
  isDownloadAble: Yup.string()
    .required("This field is required")
    .max(100, "Max 100 characters required"),
  notificationDes: Yup.string().required("This field is required"),
});

export const ADD_MODAL_VALIDATIONS = Yup.object().shape({
  productCategoryId: Yup.string().nullable().required("This field is required"),
  productCatFamilyMappingId: Yup.string().nullable().required("This field is required"),
  brandId: Yup.string().nullable().required("This field is required"),
  brickId: Yup.string().nullable().required("This field is required"),
  modelName: Yup.string()
    .required("This field is required")
    .matches(exlude_Equal_slash_start, "Field can not start with special characters")
    .max(10, "Max 10 characters required")
    .min(1, "Min 1 characters required"),
  shortName: Yup.string()
    .required("This field is required")
    .matches(exlude_Equal_slash_start, "Field can not start with special characters")
    .max(100, "Max 100 characters required")
    .min(3, "Min 3 characters required"),
  modelDesc: Yup.string()
    .required("This field is required")
    .matches(exlude_Equal_slash_start, "Field can not start with special characters")
    .min(3, "Min 3 characters required")
    .max(2000, "Max length is 2000"),
});

export const ADD_VENDOR_VALIDATIONS = Yup.object().shape({
  code: Yup.string()
    .required("This field is required")
    .matches(alphanumeric, "Only alphanumeric characters allowed")
    .min(4, "Minimum 4 characters required")
    .max(16, "Max 16. characters required"),
  name: Yup.string()
    .required("This field is required")
    .matches(validPartName, "Only alphabets, spaces and , _ . / + are allowed, and it should not start with /")
    .max(100, "Max 100 characters required"),
  typeId: Yup.string().required("This field is required"),
});
export const ADD_PARTTYPE_VALIDATIONS = Yup.object().shape({
  partTypeCode: Yup.string()
    .required("This field is required")
    .matches(alphanumeric, "Only alphanumeric characters allowed")
    .min(2, "Minimum 2 characters required")
    .max(50, "Max 50. characters required"),
  name: Yup.string()
    .required("This field is required")
    .matches(validPartName, "Only alphabets, spaces and , _ . / + are allowed, and it should not start with /")
    .min(3, "Minimum 3 characters required")
    .max(100, "Max 100 characters required"),
});

export const ADD_SPARE_VALIDATIONS = Yup.object().shape({
  code: Yup.string()
    .required("This field is required")
    .matches(alphanumeric, "Only alphanumeric characters allowed")
    .min(4, "Minimum 4 characters required")
    .max(16, "Max 16. characters required"),
  defSpareActionId: Yup.string().required("This field is required"),
  name: Yup.string()
    .required("This field is required")
    .max(100, "Max 100 characters required"),
  shortName: Yup.string()
    .required("This field is required")
    .max(100, "Max 100 characters required"),
  billingPR: Yup.string().required("This field is required"),
  retailPR: Yup.string().required("This field is required"),
  partTypeId: Yup.string().required("This field is required"),
  spec: Yup.string().required("This field is required"),
  dimension: Yup.string().required("This field is required"),
  packInfo: Yup.string().required("This field is required"),
  appInstall: Yup.string().required("This field is required"),
  spCare: Yup.string().required("This field is required"),
  description: Yup.string()
    .required("This field is required")
    .max(2000, "Max length is 2000. Char"),
});

export const SIGNIN_FORM_VALIDATION = Yup.object().shape({
  email: Yup.string()
    .required("This field is required")
    .matches(emailPattern, "Email is not valid")
    .min(4, "Minimum 4 characters required")
    .max(100, "Max 100. characters required"),
  password: Yup.string().when("email", (email) => {
    if (!email.endsWith("@ril.com"))
      return Yup.string()
        .required("This field is required")
        .matches(passwordPattern, "Password is not valid")
        .min(8, "Minimum 8 characters required")
        .max(50, "Max 50 characters required");
    return Yup.string().required("This field is required");
  }),
});

export const RESETPASSWORD_EMAIL__VALIDATION = Yup.object().shape({
  email: Yup.string()
    .required("This field is required")
    .matches(emailPattern, "Email is not valid")
    .min(4, "Minimum 4 characters required")
    .max(100, "Max 100. characters required"),
});

export const CHANGE_PASSWORD_VALIDATIONS = Yup.object().shape({
  token :Yup.string()
  .required("This field is required"),
  newPassword: Yup.string()
    .required("This field is required")
    .matches(
      passwordPattern,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    )
    .max(20, "Max 20 letter password, with at least a symbol, upper and lower case letters and a number")
    .min(
      8,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords do not match")
    .required("This field is required"),
});

export const ADD_BROADCAST_VALIDATIONS = Yup.object().shape({
  title: Yup.string()
    .required("This field is required")
    .matches(exlude_Equal_slash_start, "Field can not start with special characters")
    .min(3, "Min length should be 3 only")
    .max(255, "Max length should be 255 only"),
});
